import { useTranslation } from 'react-i18next';

import { Button, Pictogram } from '@hotjar/hotsauce';

import { BillingAlert } from './BillingAlert';

interface Props {
  onYearlyUpsellClick: () => void;
}

export const YearlyUpsellBanner = ({ onYearlyUpsellClick }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <BillingAlert
      icon={<Pictogram variant="special_offer" />}
      title={t('revenue:plans-and-billing-page.alerts.yearly-upsell.title')}
      cta={
        <Button kind="primary" onClick={() => onYearlyUpsellClick()}>
          {t('revenue:plans-and-billing-page.alerts.yearly-upsell.cta')}
        </Button>
      }
    />
  );
};
